import React, { useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { useWarta } from "../../../context/WartaContext";
import api from "../../../services/baseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";

export default function Inbox() {
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;
  const { inbox, setInbox } = useWarta();
  useEffect(() => {
    const fetchInbox = async () => {
      const response = await api.get("/notification/get", {
        params: { userId },
      });
      setInbox(response.data);
    };
    const markAllRead = async () => {
      await api.post(
        "/notification/mark-read",
        {},
        {
          params: { userId },
        }
      );
    };
    if (userId) {
      fetchInbox();
      markAllRead();
    }
  }, [userId, setInbox]);

  const handleTrashClick = async (item) => {
    const response = await api.delete("/notification/remove", {
      data: item.id,
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      fetchInbox();
      toast.success("Notification deleted successfully.");
    }
  };
  const fetchInbox = async () => {
    const response = await api.get("/notification/get", {
      params: { userId },
    });
    setInbox(response.data);
  };
  return (
    <div className="ewarta-inbox-container" style={{ marginBottom: "50px" }}>
      <div className="ewarta-inbox-header">
        Please check your inbox for the latest updates and notifications.
      </div>
      <div className="ewarta-search-result-body">
        <table style={{ padding: "25px" }}>
          <thead>
            <tr>
              <td width={200}>Date & Time</td>
              <td>Notification</td>
            </tr>
          </thead>
          <tbody>
            {inbox.map((item, index) => (
              <tr key={index}>
                <td>{item.createdAt}</td>
                <td style={{ textAlign: "left" }}>{item.message}</td>
                <td
                  style={{
                    display: "flex",
                    fontSize: "20px",
                    color: "#0078ff",
                    cursor: "pointer",
                    border: "none",
                  }}
                >
                  <FaTrash
                    onClick={() => handleTrashClick(item)}
                    style={{ color: "#0099f3", cursor: "pointer" }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ToastContainer />
    </div>
  );
}
